module.exports = __webpack_public_path__ + "img/KR.d8803c15.png";